export const YOUTUBE_API_KEY = 'AIzaSyBWpUhBl2WUoRxVC2JJX0j6HfgiiPidFUs';
export const KRIPP_CHANNEL_ID = 'UCeBMccz-PDZf6OB4aV6a3eA';

export let playlistId = null;

export async function initYoutube() {
    const responseJSON = await fetch(`https://www.googleapis.com/youtube/v3/channels?part=contentDetails&id=${KRIPP_CHANNEL_ID}&key=${YOUTUBE_API_KEY}`);
    const response = await responseJSON.json();

    playlistId = response.items[0].contentDetails.relatedPlaylists.uploads;
}


